var _dec, _class, _class2, _temp;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import brickRegistry from "./brick-registry";
import AppEvent from "./app-event";
import decopt from "zengular/src/decopt";
var Application = (_dec = decopt('listen:listeners', function (target, fn) {
  for (var _len = arguments.length, events = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    events[_key - 2] = arguments[_key];
  }

  return events.forEach(function (eventName) {
    return target.options.listeners.push({
      eventName: eventName,
      handlerName: fn
    });
  });
}, function (target) {
  return target.options.listeners = [];
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function () {
  function Application() {
    var _this = this;

    var run = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var initializeBrickRegistry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DOMContentLoaded';

    _classCallCheck(this, Application);

    Application.instance = this;
    document.addEventListener(event, function () {
      var _iterator = _createForOfIteratorHelper(_this.constructor.options.listeners),
          _step;

      try {
        var _loop = function _loop() {
          var event = _step.value;
          var eventName = event.eventName,
              handlerName = event.handlerName;
          var handler = _this[handlerName];

          _this.listen(eventName, function (eventData) {
            return handler.call(_this, eventData);
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Promise.resolve(_this.initialize()).then(function () {
        return initializeBrickRegistry ? brickRegistry.initialize() : Promise.resolve();
      }).then(function () {
        return run ? _this.run() : null;
      });
    });
  }

  _createClass(Application, [{
    key: "initialize",
    value: function initialize() {}
  }, {
    key: "run",
    value: function run() {}
  }, {
    key: "listen",
    value:
    /**
     * @param {string|Array<string>} event
     * @param {Function} handler
     */
    function listen(event, handler) {
      AppEvent.listen(event, handler, document.body);
    }
    /**
     * @param {string} event
     * @param {*} data
     * @param {{bubbles:boolean, cancelable: boolean}} options
     */

  }, {
    key: "fire",
    value: function fire(event, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        bubbles: true,
        cancelable: true
      };
      AppEvent.fire(event, data, options, document.body);
    }
  }]);

  return Application;
}(), _defineProperty(_class2, "instance", null), _temp)) || _class);
export { Application as default };